import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { createActionsHook, createStateHook, createStore } from 'react-sweet-state';
var rovoEntitlementStore = createStore({
  initialState: {
    isRovoEnabled: false
  },
  name: 'RovoEntitlementStore',
  actions: {
    setIsRovoEnabled: function setIsRovoEnabled(isRovoEnabled, reason) {
      return function (_ref) {
        var setState = _ref.setState;
        setState({
          isRovoEnabled: isRovoEnabled,
          reason: reason
        });
      };
    }
  }
});
var useStateHook = createStateHook(rovoEntitlementStore);
export var useRovoEntitlement = function useRovoEntitlement() {
  var result = useStateHook();
  return _objectSpread(_objectSpread({}, result), {}, {
    isRovoEnabled: result.isRovoEnabled
  });
};
export var useRovoEntitlementActions = createActionsHook(rovoEntitlementStore);

/**
 * This component is used to store the isRovoEnabled flag
 * the `isRovoEnabled` flag will be used in few places in the app to determine whether to return noop behaviour
 */
export var RovoEntitlementSetter = function RovoEntitlementSetter(_ref2) {
  var isRovoEnabled = _ref2.isRovoEnabled;
  var _useRovoEntitlementAc = useRovoEntitlementActions(),
    setIsRovoEnabled = _useRovoEntitlementAc.setIsRovoEnabled;
  useMemo(function () {
    setIsRovoEnabled(isRovoEnabled);
  }, [isRovoEnabled, setIsRovoEnabled]);
  return null;
};